const location = window.location.origin;
export function getAPIDomain() {
    const domain = process.env.API_DOMAIN; //This only is defined when running with webpack serve
    if (domain)
        return domain;
    //@ts-ignore
    return window.MAP_URL || '';
}
export function getAPI() {
    const domain = getAPIDomain();
    return `${domain}/api`;
}
let msalConfig = {
    clientId: '',
    tenantId: '',
    scopes: [''],
    redirectUri: '',
};
let authorizationConfig = {
    apiscope: '',
};
let mapboxApiKey = '';
export function getMapboxApiKey() {
    return mapboxApiKey;
}
// mapbox config
export const mapViewBounds = [151.16421979021112, -23.936097502120106, 151.561501328845, -23.747372156540326];
export function updateConfig(config) {
    msalConfig = config.authentication;
    authorizationConfig = config.authorization;
    mapboxApiKey = config.mapbox?.apiKey;
    maintenanceConfig = config.maintenance;
    environment = config.environment;
}
export function getMSALConfiguration() {
    return msalConfig;
}
export function getAuthorizationConfig() {
    return authorizationConfig;
}
let maintenanceConfig = 'False';
export function getMaintenance() {
    return maintenanceConfig;
}
let environment = 'production';
export function getEnvironment() {
    return environment;
}
